import React from "react";
import { CardImg } from 'reactstrap';
import { Card, CardMedia, CardContent, CardActions, Typography, Button } from "@mui/material";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import "../CategoryResults/SubCategory.css";
import { decompressToBase64, formatter } from "../../utils/common.js";
import "../Items/Item.css";
import "../CategoryResults/CategorySearchResults.css";
import Modal from "react-modal";
import ItemModal from "../Items/ItemModal.js";
import image from "../No_image_available.png";
import { AddToCart, GetCart, GetCount } from "../ShoppingCart/CartHandler.js";
import parse from "html-react-parser";
import { useState, useEffect, createContext } from "react";
import { useLocation } from "react-router";
import axios from "axios";
import { useNavigate } from "react-router-dom";


const apiUrl = process.env.REACT_APP_BASEURL;

function CategorySearchResults({
  category,
  token,
  cartCount,
  setCartCount,
  children,
  setIsSwiper,
  isSwiper
}) {
  const [activeItem, setActiveItem] = useState();
  const [startCard, setStartCard] = useState(0);
  const [endCard, setEndCard] = useState(5);
  const [categoryName, setCategoryName] = useState(category.name);

  const [filteredItems, setFilteredItems] = useState();
  const [open, setOpen] = React.useState(false);
  const [itemQty, setItemQty] = useState(1);

  const addItem = (item) => {
    AddToCart(item.itemDescription, item.images, item.itemNumber, item.price, itemQty);
    setCartCount(GetCount());
  };


  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const navigate = useNavigate();

  const FindItems = () => {
    axios
      .get(apiUrl + `/api/Items/GetAll?category=${categoryName}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        // console.log("Category Search Results: ", response.data);
        setFoundItems(response.data); // Make sure response.data is an array
        setFilteredItems(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [foundItems, setFoundItems] = useState(null);

  const GetSearchResults = () => {
    const wildSearch = `.*${searchText.replace(/ /g, ".*")}.*`;
    const matchingItems = foundItems.filter((Object) => {
      const regex = new RegExp(wildSearch, "i");
      return regex.test(Object.itemDescription);
    });
    setFilteredItems(matchingItems.length ? matchingItems : []);
  };

  const GetSubCatResults = (subCatName) => {
    // console.log("Here you are in GetSubCatResults: ", subCatName);
    const matchingItems = foundItems.filter((Object) => {
      const regex = new RegExp(subCatName, "i");
      return regex.test(Object.categoryName);
    });
    setFilteredItems(matchingItems.length ? matchingItems : []);
  };

  const handleClick = (item) => {
    setActiveItem(item);
    setIsOpen(true);
  };

  const handleSearchChange = (event) => {
    const tempSearch = event.target.value;
    // console.log(tempSearch);
    setSearchText(tempSearch);
  };

  const [isOpen, setIsOpen] = useState(false);

  const onRequestClose = () => {
    setIsOpen(false);
  };

  const [searchText, setSearchText] = useState(" ");

  const [subCategories, setSubCategories] = useState(category.children);

  useEffect(() => {
    setCategoryName(category.name);
    setSubCategories(category.children);
  }, [category]);

  useEffect(() => {
    FindItems();
  }, [categoryName]);

  const renderSubCategories = () => {
    if (!subCategories) {
      return <div className="mr-[5rem]"></div>;
    } else {
      return (
        <div onClick={toggleDrawer(false)}>
          {subCategories.map((subCat) => (
            <div
              className="sub-items"
              key={subCat.id}
              style={{ cursor: "pointer" }}
              onClick={() => GetSubCatResults(subCat.name)}
            >
              {subCat.name}
              <hr className="w-[10rem] ml-10 mb-[2rem]" />
            </div>
          ))}
        </div>
      );
    }
  };

  return (
    <div className="flex-row  category-box">
      <div className="flex-col fill">
        <div className="flex-row margin-top10 center">
          <h3>{categoryName}</h3>
          {GetSearchResults}
        </div>
        <div>
          <p className="ml-8 border-bottom inline cursor-pointer" onClick={() => navigate(-1)}>BACK</p>
          <p className=" border-bottom inline cursor-pointer all-products" onClick={() => window.location.reload(false)}>All Products</p>
        </div>
        <div className="flex-row full-width ">
          <div className="  sub-category">
            <h2 className=" sub-text">Sub Categories</h2>
            <h3 className="sub-element">{renderSubCategories()}</h3>
          </div>
          <div className="su">
            <div id="drawer-btn" onClick={toggleDrawer(true)}>Sub Category</div>
            <Drawer open={open} onClose={toggleDrawer(false)}>
              <h2 className=" sub-text">Sub Categories</h2>
              {renderSubCategories()}
            </Drawer>
          </div>

          <div className=" flex flex-wrap justify-center  gap-4  scroll">
            {/* <div className = "flex-row center">
                        <h3>{categoryName}</h3>
                    </div> */}
           
              {/* <button id="slideLeft" color="primary" onClick ={buttonLeftClick} >{String.fromCharCode(8249)}</button> */}

              {!!filteredItems &&
                filteredItems.map((item) => (
                  <Card
                    className="w-64 sm:w-56 md:w-60 lg:w-64 h-[350px] rounded-lg overflow-hidden p-2 shadow-md 
                      transition-all duration-300 ease-in-out hover:shadow-[0px_5px_15px_rgba(0,0,0,0.37)] hover:scale-[1.02] 
                      group cursor-pointer flex flex-col justify-between"
                    onClick={() => handleClick(item)}
                  >
                    {/* Image Section */}
                    <div className="h-32 flex justify-center items-center bg-white">
                      <CardImg
                        top
                        className="card-picture"
                        src={
                          "data:image/png;base64," +
                          decompressToBase64(item.images[0]?.compressedImageData)
                        }
                        id={item.itemNumber + "Img"}
                        alt={item.itemNumber}
                      />
                    </div>

                    {/* Content Section */}
                    <CardContent className="flex flex-col flex-grow justify-between p-2">
                      <Typography variant="h6" className="font-semibold text-gray-800 text-sm md:text-base">
                        {item.itemNumber}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className="text-blue-500 cursor-pointer hover:underline text-xs md:text-sm"
                      >
                        {item.categoryName}
                      </Typography>
                      <Typography
                        variant="body2"
                        className="text-gray-600 mt-1 text-xs md:text-sm line-clamp-2 h-10"
                      >
                        {item.itemDescription}
                      </Typography>
                      {item.available !== null && (
                        <Typography variant="body2" className="text-green-600 font-medium text-xs md:text-sm">
                          {item.available}
                        </Typography>
                      )}
                    </CardContent>

                    {/* Price & Action Section */}
                    <CardActions className="p-2 flex justify-between items-center">
                      <Typography
                        variant="body1"
                        className="font-bold text-gray-900 text-sm md:text-base min-w-[50px] text-right"
                      >
                        {formatter.format(item.price)}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        className="rounded-full text-xs md:text-sm w-34 h-9 flex justify-center items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          addItem(item);
                        }}
                      >
                        Add to Cart
                      </Button>
                    </CardActions>
                  </Card>
                ))}
              {/* <button id="slideRight" color="primary" onClick ={buttonRightClick}>{String.fromCharCode(8250)}</button> */}
              {isOpen ? (
                <ItemModal
                  isSwiper={isSwiper}
                  setIsSwiper={setIsSwiper}
                  item={activeItem}
                  onRequestClose={onRequestClose}
                  cartCount={cartCount}
                  setCartCount={setCartCount}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    
  );
}
export default CategorySearchResults;
